<template>
  <div>
    <v-dialog v-model="show" persistent fullscreen>
      <v-card>
        <v-app-bar dark text color="secondary">
          <page-header-title :title="$t('moduletemplates.available_module_templates')"></page-header-title>

          <v-spacer></v-spacer>

          <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    :label="$t('global.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    v-model="search_params.filter"
                    :items="$dd_admin_module_templates_filter()"
                    item-text="text"
                    item-value="key"
                    :label="$t('enrolments.status')"
                    @change="filter"
                    hide-details
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <action-button type="cancel" @click="cancel" />
          <action-button type="save" :text="$t('global.import')" @click="submit" :disabled="selected.length == 0" />
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="moduletemplates"
            :items-per-page="moduletemplates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selected"
            :expanded.sync="expanded"
            show-expand
            :must-sort="true"
          >
            <template v-slot:item.req_module_id="{ item }">
              {{ item.req_module != null ? item.req_module.name : "" }}
            </template>

            <template v-slot:item.status="{ item }">
              {{ $dd_module_templates_status(item.status) }}
            </template>

            <template v-slot:item.admin_id="{ item }">
              {{ item.admin_id ? $t("global.location_admin") : $t("global.location_local") }}
            </template>

            <template v-slot:expanded-item="{ item }">
              <td :colspan="8">
                <v-container grid-list-md class="mx-0 px-0 mt-0 pt-0">
                  <v-layout row wrap class="py-4">
                    <v-flex lg3 md3 sm6 xs12>
                      <v-text-field
                        :value="item.coursetypegroup ? item.coursetypegroup.name : ''"
                        :label="$t('moduletemplates.coursetypegroup_id')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg4 md3 sm6 xs12>
                      <v-text-field
                        :value="item.coursetype ? item.coursetype.name : ''"
                        :label="$t('moduletemplates.coursetype_id')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md3 sm6 xs12>
                      <v-text-field
                        :value="item.name"
                        :label="$t('moduletemplates.name')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md4 sm6 xs12>
                      <v-text-field
                        :value="$dd_module_templates_status(item.status)"
                        :label="$t('moduletemplates.status')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :value="item.description"
                        rows="3"
                        auto-grow
                        :label="$t('moduletemplates.description')"
                        :readonly="true"
                        hide-details
                      ></v-textarea>
                    </v-flex>
                    <v-flex lg2 md3 sm6 xs12>
                      <v-checkbox
                        v-model="item.add_to_expertise"
                        :label="$t('moduletemplates.add_to_expertise')"
                        :readonly="true"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex lg2 md3 sm6 xs12>
                      <v-checkbox
                        v-model="item.add_to_course_certificate"
                        :label="$t('moduletemplates.add_to_course_certificate')"
                        :readonly="true"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field
                        :value="item.req_coursetemplate ? item.req_coursetemplate.name : ''"
                        :label="$t('moduletemplates.req_coursetemplate_id')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field
                        :value="item.req_module ? item.req_module.name : ''"
                        :label="$t('moduletemplates.req_module_id')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md3 sm4 xs12>
                      <v-text-field
                        :value="item.req_hours"
                        :label="$t('moduletemplates.req_hours')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md4 sm6 xs12>
                      <v-checkbox
                        v-model="item.is_included"
                        :label="$t('moduletemplates.is_included')"
                        :readonly="true"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex md3 sm4 xs12>
                      <v-text-field
                        :value="item.internal_note"
                        :label="$t('moduletemplates.internal_note')"
                        :readonly="true"
                        hide-details
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-card class="mt-4">
                    <v-app-bar dense text color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("moduleoptions.title") }}</v-toolbar-title>
                    </v-app-bar>
                    <v-card-text class="pa-4">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">{{ $t("moduleoptions.name") }}</th>
                                  <th class="text-left">{{ $t("moduleoptions.price") }}</th>
                                  <th class="text-left">{{ $t("moduleoptions.hours") }}</th>
                                </tr>
                              </thead>
                              <tbody v-for="moduleoption in item.moduleoptions" :key="moduleoption.id">
                                <tr>
                                  <td scope="row" :class="moduleoption.comment ? 'py-2' : ''">
                                    {{ moduleoption.name }}
                                    <p v-if="moduleoption.comment" class="font-italic mb-0">( {{ moduleoption.comment }} )</p>
                                  </td>
                                  <td scope="row">{{ moduleoption.price }}</td>
                                  <td scope="row">{{ moduleoption.hours }}</td>
                                </tr>
                                <tr>
                                  <td :colspan="4" class="ct-td">
                                    <v-card>
                                      <v-app-bar flat dense color="white">
                                        <v-toolbar-title class="body-2">{{ $t("coursetypes.title") }}</v-toolbar-title>
                                      </v-app-bar>
                                      <v-card-text class="pa-4">
                                        <v-simple-table>
                                          <template v-slot:default>
                                            <thead>
                                              <tr>
                                                <th class="text-left">
                                                  {{ $t("moduleoptioncoursetypes.name") }}
                                                </th>
                                                <th class="text-left">
                                                  {{ $t("moduleoptioncoursetypes.price") }}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <template v-for="coursetype in moduleoption.coursetypes">
                                                <tr :key="coursetype.id + '-td1'" :class="coursetype.comment ? 'tr-no-bottom-border' : ''">
                                                  <td scope="row">
                                                    {{ coursetype.name }}
                                                  </td>
                                                  <td scope="row">
                                                    {{ coursetype.price }}
                                                  </td>
                                                </tr>
                                                <tr :key="coursetype.id + '-td2'" v-if="coursetype.comment">
                                                  <td colspan="3">
                                                    <span> {{ $t("moduleoptioncoursetypes.comment") }}: {{ coursetype.comment }} </span>
                                                  </td>
                                                </tr>
                                              </template>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-card-text>
                                    </v-card>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-container>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "AdminModuleTemplatesPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      url: "",
      selected: [],

      moduletemplates: [],

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["start_datetime"],
        sortDesc: []
      },
      search_params: {
        name: "",
        status: 1,
        filter: "new-and-updated"
      },

      expanded: []
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("moduletemplates.name"), value: "name" },
          { text: this.$t("moduletemplates.internal_note"), value: "internal_note" },
          { text: this.$t("moduletemplates.req_hours"), value: "req_hours" },
          { text: this.$t("moduletemplates.price"), value: "price" },
          { text: this.$t("moduletemplates.req_module_id"), value: "req_module_id" },
          { text: this.$t("moduletemplates.status"), value: "status" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.refresh = true
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.moduletemplates = []
          this.list()
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "moduletemplate/admintemplates"
  },

  methods: {
    list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.moduletemplates = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false
        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },

    cancel() {
      this.$emit("callback_adminmt_cancel")
    },

    submit() {
      let vm = this

      axios
        .post(this.API_URL + "moduletemplate/admintemplates/import", {
          ids: this.selected
            .map(function (ct) {
              return ct.id
            })
            .join(",")
        })
        .then((res) => {
          this.$awn.success(vm.$t("moduletemplates.import_success"))
          this.$emit("callback_adminmt_submit", this.selected)
        })
        .catch((err) => {
          this.$awn.alert(vm.$t("moduletemplates.import_failed"))
        })
    }
  }
}
</script>

<style scoped></style>
